module.exports = __webpack_public_path__ + "img/9788970133720.d322ee48.jpg";